import { AGG_PROJECT_PAGE, AGG_PROJECT_PATH_PATTERN } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const aggProjectRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: AGG_PROJECT_PAGE,
	path: AGG_PROJECT_PATH_PATTERN,
	capabilities: ['projects_app:access'],
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
	featureGating: {
		gates: ['agg-projects-view'],
		behavior: { type: 'enabled' },
	},
});
